"use client";
import { authClient } from "@/lib/client/betterauth/auth-client";
import { FaGoogle } from "react-icons/fa";

const LoginGoogle = () => {
  const handleSignIn = async () => {
    await authClient.signIn.social({
      provider: "google",
      callbackURL: "/app",
    });
  };

  return (
    <button
      onClick={handleSignIn}
      className="flex h-10 w-full items-center justify-center gap-3 rounded-md border border-input bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground"
      type="button"
    >
      <FaGoogle className="h-4 w-4" />
      <span>Continue with Google</span>
    </button>
  );
};

export default LoginGoogle;
